import { EpStepContent } from '../HookFormComponents/components';
import styles from './EpRadioGroup.module.scss';

type EpRadioGroupProps = {
  legend: string;
  children: React.ReactNode;
};

export const EpRadioGroup = ({ legend, children }: EpRadioGroupProps) => {
  return (
    <fieldset className={styles['radio__group']}>
      <EpStepContent.Label label={legend}>
        <div className={styles['radio__inputs']}>{children}</div>
      </EpStepContent.Label>
    </fieldset>
  );
};
